import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ChartCommonModule } from '@swimlane/ngx-charts';
import { ReactiveValidationModule } from 'angular-reactive-validation';
import { NgxPopperModule } from 'ngx-popper';
import 'reflect-metadata';
import { from, Observable } from 'rxjs';

import { TooltipsModule } from 'ionic4-tooltips';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './components/footer/footer.component';
import { NavModule } from './components/nav/nav.module';
import { CoreModule } from './core/core.module';
import { AuthInterceptor } from './interceptors/auth-interceptor';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';
import { AuthService } from './services/auth.service';

export const createTranslateLoader = () => new WebpackTranslateLoader();

export class WebpackTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<any> {
    return from(import(`../assets/i18n/${lang}.json`));
  }

}

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
  ],
  entryComponents: [],
  imports: [
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    IonicModule.forRoot(),
    HttpClientModule,
    ReactiveValidationModule.forRoot({
      displayValidationMessageWhen: (control, formSubmitted) =>
        control?.touched === true || formSubmitted === true
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: []
      }
    }),
    TooltipsModule.forRoot(),
    NgxPopperModule.forRoot({ applyClass: 'ulm-popper', applyArrowClass: 'ulm-popper-arrow' }),
    NavModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ChartCommonModule // FIX for injector to work in side a viewcontainerref/dialog
  ],
  providers: [
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
